import React from "react";
import { ExternalLink, Share2, Archive, ArrowUpCircle, Edit } from "lucide-react";
import ActionButton from "@/components/dashboard/ActionButton";

interface OfferPageRowActionsProps {
  pageId: string;
  status: string;
  onCopyLink: (id: string) => void;
  onArchive: (id: string) => void;
  onEdit?: (id: string) => void;
  stopPropagation?: boolean;
}

const OfferPageRowActions: React.FC<OfferPageRowActionsProps> = ({
  pageId,
  status,
  onCopyLink,
  onArchive,
  onEdit,
  stopPropagation = true,
}) => {
  const handleClick = (e: React.MouseEvent, action: () => void) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
    action();
  };

  return (
    <div className="flex justify-end space-x-1">
      {status === "active" ? (
        <>
          <ActionButton
            icon={<Share2 className="h-4 w-4" />}
            label="Copy link"
            onClick={(e) => handleClick(e, () => onCopyLink(pageId))}
          />
          {onEdit && (
            <ActionButton
              icon={<Edit className="h-4 w-4" />}
              label="Edit bundle"
              onClick={(e) => handleClick(e, () => onEdit(pageId))}
            />
          )}
          <ActionButton
            icon={<ExternalLink className="h-4 w-4" />}
            label="View bundle"
            to={`/bundle/${pageId}`}
          />
          <ActionButton
            icon={<Archive className="h-4 w-4" />}
            label="Archive bundle"
            onClick={(e) => handleClick(e, () => onArchive(pageId))}
            variant="ghost"
          />
        </>
      ) : (
        <div className="flex items-center space-x-2">
          <span className="text-sm text-gray-500">Activate</span>
          <ActionButton
            icon={<ArrowUpCircle className="h-4 w-4 text-green-500" />}
            label="Activate"
            onClick={(e) => handleClick(e, () => onArchive(pageId))}
            variant="ghost"
          />
        </div>
      )}
    </div>
  );
};

export default OfferPageRowActions;
